// extracted by mini-css-extract-plugin
module.exports = {"test__sets":"test__sets___3GUWI","wrap":"wrap___3LmEZ","list":"list___1RfZs","no-terms":"no-terms___3RZN_"};